// Entry point for the build script in your package.json
import "./controllers"
import { createIcons, icons } from 'lucide'
import './charts'

// Initialize lucide icons
document.addEventListener('DOMContentLoaded', () => {
  createIcons({
    icons: icons
  })
});
